import { DadosArquivos } from './styles'
import ArquivoLinha from './ArquivoLinha'

export default function ArquivoBox({ arquivos, setArquivos, titulo, motivoRecusa, chancela }) {
    return (
        <>
            <DadosArquivos.Header style={titulo.includes('Documento Principal') ? { paddingTop: '0px' } : { paddingTop: '10px' }}>
                {motivoRecusa !== null && chancela === null &&
                    (<><span>{titulo}</span><span style={{ float: 'right', paddingRight: '5px', color: 'red' }}>{'RECUSADA'}</span></>)                    
                }

                {chancela !== null && motivoRecusa === null &&
                    (<><span>{titulo}</span><span style={{ float: 'right', paddingRight: '5px', color: 'blue' }}>{'Chancela ' + chancela}</span></>)                    
                }

                { motivoRecusa === null && chancela === null &&
                    (<span>{titulo}</span>)
                }
                
            </DadosArquivos.Header>
            <DadosArquivos.Body>
                {arquivos && arquivos.map((item) => (
                    <ArquivoLinha arquivo={item} />
                ))}
                {
                    motivoRecusa && (<ArquivoLinha motivoRecusa={motivoRecusa}></ArquivoLinha>)
                }
            </DadosArquivos.Body>
        </>
    )
}